import wueActionMap from './wueActionMap';
import replaceValues from './replaceValues';

// Map action values
export default (eventData) =>
	replaceValues(eventData.action, wueActionMap) || eventData.specialType;
